import React, { useEffect, useState } from "react"
import {
    withRouter,
    useParams
} from "react-router-dom"
import * as appAction from "../../store/b3BlcmF0aW9uc0/actions"
import PropTypes from "prop-types"
import { connect, useSelector } from "react-redux"
import {
    Col,
    UncontrolledTooltip,
    // Table,
    //Button,
    Row,
    // Badge
    Card,
    CardBody,
    Nav,
} from "reactstrap"
import OperationsClientFeedback from "./OperationClientFeedback"
import OperationsFreelancerQc from "./OperationsFreelancerQc"
import OperationsEventIssues from "./OperationsEventIssues"
import OperationsCheckList from "./OperationsCheckList"
import { isEmpty } from "lodash"
import moment from "moment"

const OperationsApp = (props) => {
    const { dispatch } = props
    let { id } = useParams()

    const [appTab, setAppTab] = useState("Event Logs")
    useEffect(() => {
        if (appTab === "Event Logs")
            dispatch(appAction.loadEcApp(id))
    }, [appTab])
    const update = useSelector(state => state.operationsFollowUp)
    const { app_list } = update
    console.log(app_list)
    const sessionUpdate = useSelector((specificstate) => specificstate.session)
    const { user = [] } = sessionUpdate

    //date format from localstorage
    const authUser = localStorage.getItem("authUser")

    const dateLogin = JSON.parse(authUser)

    const setDate =
        !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
            ? dateLogin.setting.dateFormate.toUpperCase()
            : !isEmpty(user) && user.setting && user.setting.dateFormate
                ? user.setting.dateFormate.toUpperCase()
                : []

    const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
    let appButtons = [
        {
            label: "Event Logs",
            color:
                appTab === "Event Logs"
                    ? "btn btn-success"
                    : "btn btn-warning",
        },
        {
            label: "Client Feedback",
            color:
                appTab === "Client Feedback"
                    ? "btn btn-success"
                    : "btn btn-warning",
        },
        {
            label: "Freelancer Qc",
            color:
                appTab === "Freelancer Qc"
                    ? "btn btn-success"
                    : "btn btn-warning",
        },
        {
            label: "Event Issues",
            color:
                appTab === "Event Issues"
                    ? "btn btn-success"
                    : "btn btn-warning",
        },
        {
            label: "Checklist",
            color:
                appTab === "Checklist"
                    ? "btn btn-success"
                    : "btn btn-warning",
        },
    ]
    // const dummyData = [

    //     {
    //         id: 1,
    //         eventnO: "EVENT 01",
    //         eventName: "Weeding",
    //         checkIn: "muthu",
    //         checkinDate: "23-11-23",
    //         checkout: "dinesh",
    //         checkoutDate: "24-11-23"
    //     },
    //     {
    //         id: 2,
    //         eventnO: "EVENT 02",
    //         eventName: "Weeding",
    //         checkIn: "muthu",
    //         checkinDate: "23-11-23",
    //         checkout: "dinesh",
    //         checkoutDate: "24-11-23"
    //     },
    //     {
    //         id: 3,
    //         eventnO: "EVENT 03",
    //         eventName: "Weeding",
    //         checkIn: "muthu",
    //         checkinDate: "23-11-23",
    //         checkout: "dinesh",
    //         checkoutDate: "24-11-23"
    //     },

    // ]
    const [oddColumnData, setOddColumnData] = useState([])
    const [evenColumnData, setEvenColumnData] = useState([])
   // console.log(dummyData, "dummy")
    useEffect(() => {
        if (app_list && app_list.length > 0) {
            var array = app_list
            var evenColumns = []
            var oddColumns = []

            for (var i = 0; i < array.length; i++) {
                if (i % 2 === 0) {
                    oddColumns.push(array[i])
                } else {
                    evenColumns.push(array[i])
                }
            }

            setOddColumnData(oddColumns)
            setEvenColumnData(evenColumns)
        }
    }, [app_list])
    console.log(evenColumnData)
    console.log(oddColumnData)
    return (
        <React.Fragment>
            <Row className="quote-head-content">
                <p className="quote-head">
                    App
                    <span className="quote-info">
                        <i
                            style={{ color: "grey" }}
                            id="DeliverablesInfo"
                            aria-hidden="true"
                            className="fa fa-info-circle ms-1"
                        ></i>
                        <UncontrolledTooltip placement="right" target="DeliverablesInfo">
                            App
                        </UncontrolledTooltip>
                    </span>
                </p>
                <Col md="12" lg="12" xl="12">
                    <Nav className="nav">
                        {appButtons.map((data, index) => {
                            return (
                                <button
                                    key={index}
                                    type="submit"
                                    className={data.color}
                                    style={{
                                        marginRight: "20px",
                                        marginTop: "10px",
                                    }}
                                    onClick={() => {
                                        setAppTab(data.label)
                                    }}
                                >
                                    {data.label}
                                </button>
                            )
                        })}
                    </Nav>
                </Col>
                {(() => {
                    switch (appTab) {
                        case "Event Logs":
                            return (
                                <>
                                    <Row className="quote-head-content">
                                        <p className="quote-head">
                                            Event Logs
                                            <span className="quote-info">
                                                <i
                                                    style={{ color: "grey" }}
                                                    id="event"
                                                    aria-hidden="true"
                                                    className="fa fa-info-circle ms-1"
                                                ></i>
                                                <UncontrolledTooltip
                                                    placement="right"
                                                    target="event"
                                                >
                                                    Event Logs
                                                </UncontrolledTooltip>
                                            </span>
                                        </p>
                                    </Row>
                                    {!isEmpty(app_list) && !isEmpty(app_list.data) &&app_list.data.length > 0 ? (<Row>
                                        <Col md="6" lg="6" xl="6" className="mt-3">
                                            <Card style={{ border: "2px solid rgb(229,229,229)", borderRadius: "4px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                                                <CardBody>
                                                    {!isEmpty(oddColumnData) && oddColumnData.map((data, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <Col md="12" lg="12" xl="12">
                                                                    <p
                                                                        style={{
                                                                            fontSize: "15px",
                                                                            marginBottom: "12px",
                                                                            fontWeight: 550,
                                                                            marginTop: "10px",
                                                                        }}
                                                                    >
                                                                        {data.eventNo}
                                                                    </p></Col>
                                                                <Col md="12" lg="12" xl="12" style={{ marginBottom: "-16px" }}>
                                                                    <p>Checkin By : <span style={{ fontWeight: "550" }}> {data.PhotographerCheckInCode + "-" + data.PhotographerCheckInName}</span></p>
                                                                    <p>Checkin Date & Time : <span style={{ fontWeight: "550" }}> {moment(data.PhotographerCheckInDateTime).format(`${dateFormat} ${"hh:mm A"}`)}</span></p>
                                                                    <p>Checkout By :  <span style={{ fontWeight: "550" }}>{data.PhotographerCheckOutCode + "-" + data.PhotographerCheckOutName}</span></p>
                                                                    <p>Checkout Date & Time : <span style={{ fontWeight: "550" }}>{moment(data.PhotographerCheckOutDateTime).format(`${dateFormat} ${"hh:mm A"}`)}</span></p>
                                                                </Col>
                                                            </div>)
                                                    })}

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col md="6" lg="6" xl="6" className="mt-3">
                                            <Card style={{ border: "2px solid rgb(229,229,229)", borderRadius: "4px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                                                <CardBody>
                                                    {!isEmpty(evenColumnData) && evenColumnData.map((data, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <Col md="12" lg="12" xl="12">
                                                                    <p
                                                                        style={{
                                                                            fontSize: "15px",
                                                                            marginBottom: "12px",
                                                                            fontWeight: 550,
                                                                            marginTop: "10px",
                                                                        }}
                                                                    >
                                                                        {data.eventNo}
                                                                    </p></Col>
                                                                <Col md="12" lg="12" xl="12" style={{ marginBottom: "-16px" }}>
                                                                    <p>Checkin By : <span style={{ fontWeight: "550" }}> {data.PhotographerCheckInCode + "-" + data.PhotographerCheckInName}</span></p>
                                                                    <p>Checkin Date & Time : <span style={{ fontWeight: "550" }}> {moment(data.PhotographerCheckInDateTime).format(`${dateFormat} ${"hh:mm A"}`)}</span></p>
                                                                    <p>Checkout By :  <span style={{ fontWeight: "550" }}>{data.PhotographerCheckOutCode + "-" + data.PhotographerCheckOutName}</span></p>
                                                                    <p>Checkout Date & Time : <span style={{ fontWeight: "550" }}>{moment(data.PhotographerCheckOutDateTime).format(`${dateFormat} ${"hh:mm A"}`)}</span></p>
                                                                </Col>
                                                            </div>)
                                                    })}

                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>) : (
                                        <Col md="12" lg="12" xl="12" className="mt-3">
                                            <Card style={{ border: "2px solid rgb(229,229,229)", borderRadius: "4px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                                                <CardBody>
                                                    <div className="text-align-center mt-3 mb-3">
                                                        No Records Found
                                                    </div>

                                                </CardBody></Card>
                                        </Col>
                                    )}
                                </>
                            )
                        case "Client Feedback":
                            return (
                                <Col>
                                    <OperationsClientFeedback />
                                </Col>
                            )
                        case "Freelancer Qc":
                            return (
                                <Col>
                                    <OperationsFreelancerQc />
                                </Col>
                            )
                        case "Event Issues":
                            return (
                                <Col>
                                    <OperationsEventIssues />
                                </Col>
                            )
                            case "Checklist":
                                return (
                                    <Col>
                                        <OperationsCheckList />
                                    </Col>
                                )
                    }
                })()}
            </Row>






        </React.Fragment>
    )
}

OperationsApp.propTypes = {
    dispatch: PropTypes.func
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}

const mapStateToProps = () => ({
    //mapstate to prop
})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OperationsApp)
)


